import { BuilderConfig } from '../../types/Builder';
import BusinessHubStats, { BusinessHubStatsProps } from './business-hub-stats';

export const BusinessHubStatsConfig = {
    name: 'Business Hub Stats',
    inputs: [
        {
            name: 'stats',
            type: 'list',
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                },
                {
                    name: 'stats',
                    type: 'list',
                    subFields: [
                        {
                            name: 'percent',
                            type: 'string',
                            max: 100,
                            min: 0,
                        },
                        {
                            name: 'plus',
                            type: 'boolean',
                        },
                        { name: 'hidePercent', type: 'boolean' },
                        {
                            name: 'description',
                            type: 'string',
                        },
                    ],
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubStatsProps> = {
    component: BusinessHubStats,
    config: BusinessHubStatsConfig,
};

export default builderConfig;
